<div class="cycle flex__child--auto flex--column" data-test="cycle">
  <router-outlet></router-outlet>
</div>
